import { render, staticRenderFns } from "./FormServices.vue?vue&type=template&id=5137f05e&scoped=true"
import script from "./FormServices.vue?vue&type=script&lang=js"
export * from "./FormServices.vue?vue&type=script&lang=js"
import style0 from "./FormServices.vue?vue&type=style&index=0&id=5137f05e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5137f05e",
  null
  
)

export default component.exports